// Angular
import { Component, OnDestroy, OnInit } from '@angular/core';
// Service
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { SignalRService } from '../../../signal-r/service/signal-r.service';
import { GlobalUtils } from '../../../utils/global.utils';
// Model
import { AUTH_IFRAME_LOADING_TIMEOUT_MS, AUTHMESSAGE } from '../../../model/role.model';
import { Logout, SetLoginMessage } from '../../action/auth.action';
// Other
import { Store } from '@ngxs/store';
import { Subject } from 'rxjs';

@Component({
	selector: 'cv-login',
	templateUrl: './login.component.html',
	styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit, OnDestroy {
	public today: number = Date.now();
	submitted = false;
	isLoading: boolean;
	returnUrl: string;
	authFailure: boolean;
	authFailMsg = AUTHMESSAGE.FAIL;
	showButton = true;
	public isInsideIframe = GlobalUtils.isInsideIframe();

	private atComponentDestroy = new Subject();
	private iframeLoadingTimeoutId: ReturnType<typeof setTimeout> | null = null;

	constructor(
		private signalRService: SignalRService,
		private oidcSecurityService: OidcSecurityService,
		private store: Store
	) {
		this.signalRService.stopConnection();
	}

	/**
	 * On submit.
	 */
	onSubmit(): void {
		this.oidcSecurityService.authorize();
	}

	ngOnInit(): void {
		const msg = this.store.selectSnapshot(state => state.user);
		if (msg.loginMessage) {
			this.authFailMsg = msg.loginMessage;

			if (this.isInsideIframe) {
				this.authFailMsg = AUTHMESSAGE.IFRAME_LOADING;
				// After 10 seconds kill the session
				this.iframeLoadingTimeoutId = setTimeout(() => {
					if (this.authFailMsg === AUTHMESSAGE.IFRAME_LOADING) {
						this.authFailMsg = AUTHMESSAGE.IFRAME_ERROR;
						this.showButton = false;
						// Try to logout
						this.store.dispatch(new Logout(true));
						this.store.dispatch(new SetLoginMessage(AUTHMESSAGE.FAIL));
						// Force to clear session storage and local storage
						setTimeout( () => {
							localStorage.clear();
							sessionStorage.clear();
							// Notify the host to close the iframe if needed
							window.top.postMessage({
								app: 'EMBEDDED-APP',
								appUniqueID: null,
								event: {
									type: 'EXTERNAL_ERROR',
									close: true
								}
							}, '*');
						}, 500);
					}
				}, AUTH_IFRAME_LOADING_TIMEOUT_MS);
			}

			if (this.authFailMsg === AUTHMESSAGE.TOKEN_EXPIRED) {
				this.showButton = false;
			}
		}

	}

	/**
	 * Close all when the element is destroyed
	 * in case a Sub Component remains visible
	 */
	ngOnDestroy(): void {
		this.atComponentDestroy.next({});
		this.atComponentDestroy.unsubscribe();

		if (this.iframeLoadingTimeoutId) {
			clearTimeout(this.iframeLoadingTimeoutId);
			this.iframeLoadingTimeoutId = null;
		}
	}
}
